// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  blog: icon("ic_blog"),
  cart: icon("ic_cart"),
  chat: icon("ic_chat"),
  mail: icon("ic_mail"),
  user: icon("ic_user"),
  file: icon("ic_file"),
  lock: icon("ic_lock"),
  label: icon("ic_label"),
  blank: icon("ic_blank"),
  kanban: icon("ic_kanban"),
  folder: icon("ic_folder"),
  banking: icon("ic_banking"),
  booking: icon("ic_booking"),
  invoice: icon("ic_invoice"),
  calendar: icon("ic_calendar"),
  disabled: icon("ic_disabled"),
  external: icon("ic_external"),
  menuItem: icon("ic_menu_item"),
  ecommerce: icon("ic_ecommerce"),
  analytics: icon("ic_analytics"),
  dashboard: icon("ic_dashboard"),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------

  {
    subheader: "general",
    items: [
      {
        title: "Dashboard",
        path: PATH_DASHBOARD.general.dashboard,
        icon: ICONS.dashboard,
      },
    ],
  },

  {
    subheader: "Organisation",
    items: [
      {
        title: "Metadata",
        path: PATH_DASHBOARD.metadata.root,
        icon: ICONS.banking,
        children: [
          { title: "Year", path: PATH_DASHBOARD.metadata.year },
          { title: "Departments", path: PATH_DASHBOARD.metadata.departments },
          {
            title: "Learning Centres",
            path: PATH_DASHBOARD.metadata.learningcentres,
          },
          { title: "Grades", path: PATH_DASHBOARD.metadata.grades },
        ],
      },
      {
        title: "Staff",
        path: PATH_DASHBOARD.staff.root,
        icon: ICONS.user,
        children: [
          { title: "Add New", path: PATH_DASHBOARD.staff.new },
          { title: "List", path: PATH_DASHBOARD.staff.list },
          { title: "Attendance", path: PATH_DASHBOARD.staff.attendance },
          { title: "Temporary", path: PATH_DASHBOARD.staff.temp },
        ],
      },
      {
        title: "Parents",
        path: PATH_DASHBOARD.parent.root,
        icon: ICONS.user,
        children: [
          { title: "Add New", path: PATH_DASHBOARD.parent.new },
          { title: "List", path: PATH_DASHBOARD.parent.list },
        ],
      },
      {
        title: "Students",
        path: PATH_DASHBOARD.students.root,
        icon: ICONS.folder,
        children: [
          { title: "Add New", path: PATH_DASHBOARD.students.new },
          { title: "List", path: PATH_DASHBOARD.students.list },
          { title: "Applications", path: PATH_DASHBOARD.students.applications },
        ],
      },
    ],
  },
  {
    subheader: "Academics",
    items: [
      {
        title: "ClassList",
        path: PATH_DASHBOARD.classlist.root,
        icon: ICONS.file,
      },
      {
        title: "Pace Tracking",
        path: PATH_DASHBOARD.tracking.root,
        icon: ICONS.calendar,
      },
      {
        title: "Subjects",
        path: PATH_DASHBOARD.subjects.root,
        icon: ICONS.menuItem,
        children: [
          { title: "ACE Subjects", path: PATH_DASHBOARD.subjects.list },
          { title: "Other Subjects", path: PATH_DASHBOARD.subjects.other },
        ],
      },
      {
        title: "Pace Management",
        path: PATH_DASHBOARD.paces.root,
        icon: ICONS.booking,
        children: [
          { title: "Add New", path: PATH_DASHBOARD.paces.new },
          { title: "List", path: PATH_DASHBOARD.paces.list },
          { title: "Inventory", path: PATH_DASHBOARD.paces.inventory },
          { title: "Paces Online", path: PATH_DASHBOARD.paces.store },
        ],
      },
      {
        title: "Pace Ordering",
        path: PATH_DASHBOARD.projections.root,
        icon: ICONS.cart,
        children: [
          { title: "Projections", path: PATH_DASHBOARD.projections.list },
          { title: "Orders", path: PATH_DASHBOARD.projections.orders },
        ],
      },
    ],
  },

  {
    subheader: "Co-curricular",
    items: [
      {
        title: "Checkin Activitiies",
        path: PATH_DASHBOARD.activities.root,
        icon: ICONS.external,
        children: [
          { title: "List", path: PATH_DASHBOARD.activities.list },
          { title: "Checkins", path: PATH_DASHBOARD.activities.checkins },
        ],
      },
    ],
  },
  {
    subheader: "Finance",
    items: [
      {
        title: "Billing",
        path: PATH_DASHBOARD.finance.root,
        icon: ICONS.invoice,
        children: [
          { title: "Pace Billing", path: PATH_DASHBOARD.finance.pacebilling },
        ],
      },
    ],
  },
];

export default navConfig;
